import React from 'react';
import UploadIcon from '../icons/upload.svg';
import PropTypes from 'prop-types';

const BannerUploadBox = ({
  handleClick = () => {},
  preview = null,
  onClear = () => {},
  className = '',
  style = {}
}) => {
  return (
    <div
      className={`flex flex-row items-center justify-between ${className || ''}`}
      style={style}
      onClick={handleClick}
    >
      {preview ? (
        <div className="flex items-center justify-between w-full">
          <img
            src={preview}
            alt="Banner Preview"
            className="w-32 h-16 object-cover rounded"
          />
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
            className="px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Clear
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-between w-full cursor-pointer">
          <span className="text-gray-400">Upload a banner</span>
          <img
            src={UploadIcon}
            alt="Upload Icon"
            className="upload-icon w-[20px] h-[20px]"
          />
        </div>
      )}
    </div>
  );
};

BannerUploadBox.propTypes = {
  handleClick: PropTypes.func.isRequired,
  preview: PropTypes.string,
  onClear: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default BannerUploadBox;